<template>
  <v-dialog @click:outside="onClose" width="unset" :value="value">
    <v-card class="pt-2 pb-3 px-2">
      <v-card-title class="text-h5">
        {{ bookData.paymentMethodTitle }}
      </v-card-title>
      <v-card-text class="d-flex align-center flex-md-row flex-column mt-3">
        <PaymentCard
          class="mr-4 mb-md-0 mb-3"
          :image="require('@/assets/img/payment/mir_logo.png')"
          :label="bookData.mirCardTitle"
          @onClick="onPaymentMethodClickHandler(paymentTypes.MIR)"
          :is-active="selectedPaymentType === paymentTypes.MIR"
        />
        <PaymentCard
          :image="require('@/assets/img/payment/wallet.svg')"
          :label="bookData.otherCardTitle"
          @onClick="onPaymentMethodClickHandler(paymentTypes.OTHER)"
          :is-active="selectedPaymentType === paymentTypes.OTHER"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onSubmitHandler" color="#FFA903" dark>
          {{ bookData.paymentButtonTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentCard from "@/components/payment-method-dialog/PaymentCard";

export const PaymentType = Object.freeze({
  MIR: "mir",
  OTHER: "other"
});

export default {
  name: "PaymentMethodDialog",
  components: { PaymentCard },
  props: ["value"],
  computed: {
    bookData() {
      return this.$t("book");
    }
  },
  data() {
    return {
      paymentTypes: PaymentType,
      selectedPaymentType: PaymentType.OTHER
    };
  },
  methods: {
    onPaymentMethodClickHandler(paymentType) {
      this.selectedPaymentType = paymentType;
    },
    onSubmitHandler() {
      this.$emit("onSubmit", this.selectedPaymentType);
    },
    onClose() {
      this.$emit("onClose", false);
    }
  }
};
</script>

<style scoped></style>
